/*
 * Blur-up progressive image loading.
 *
 * Pairs with snippets/image-element.liquid's `lqip: true` option: a tiny
 * blurred placeholder (.gsafe-lqip-bg) sits behind the real image
 * (.gsafe-lqip-main) inside a .gsafe-lqip-wrap. Once the real image has
 * actually finished loading, this adds `.is-loaded` to the wrapper, which
 * gsafe-image-blurup.css uses to fade the placeholder out / the real image
 * in.
 *
 * Deliberately independent of the theme's AOS-driven <image-element>
 * proximity fade (which fires ~400px before the image is even requested,
 * not on actual load) — this needs the real "the bytes are here" signal.
 */
(function () {
  function reveal(el) {
    var wrap = el.closest('.gsafe-lqip-wrap');
    if (wrap) wrap.classList.add('is-loaded');
  }

  function checkAlreadyLoaded() {
    document.querySelectorAll('.gsafe-lqip-wrap .gsafe-lqip-main').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) reveal(img);
    });
  }

  // Native `load` events don't bubble, but they do fire during the capture
  // phase on ancestors — so one delegated listener on `document` (capture:
  // true) catches every current and future .gsafe-lqip-main load, without
  // needing to attach a listener per image.
  document.addEventListener(
    'load',
    function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('gsafe-lqip-main')) {
        reveal(target);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAlreadyLoaded);
  } else {
    checkAlreadyLoaded();
  }

  // Theme-editor section re-renders can inject already-cached images that
  // won't fire a fresh load event.
  document.addEventListener('shopify:section:load', checkAlreadyLoaded);
})();
